import { SubmitHandler, useForm } from 'react-hook-form'
import * as Yup from 'yup'

import { yupResolver } from '@hookform/resolvers/yup'

import { useAppDispatch } from 'src/store'
import { uploadHeadImage } from 'src/useCase/automaticPlan'
import uiActions from 'src/store/ui/notification'
import { trackStep, JOURNEY_STEP } from 'src/utils/tracker'

export const FILE_SIZE = 1024 * 1024 * 3

export type FormValues = {
  image: File
}

export const useUploadImage = () => {
  const dispatch = useAppDispatch()

  const validationSchema = Yup.object().shape({})

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    if (data?.image?.size > FILE_SIZE) {
      dispatch(
        uiActions.onNotification({
          type: 'error',
          message: '6MB以下の画像をアップロードしてください。',
        }),
      )
    } else {
      try {
        // [SCOPE] .unwrap() + await added so trackStep only fires after a
        // confirmed successful upload — affects UploadImage flow only.
        // Pre-existing behavior: trackStep fired immediately, before the
        // dispatch even ran, overcounting journey analytics on failure.
        // New behavior: trackStep fires only once uploadHeadImage resolves.
        await dispatch(uploadHeadImage({ data }) as any).unwrap()

        trackStep(JOURNEY_STEP.IMAGE_UPLOADED)
      } catch {
        // [SCOPE] Catch added alongside the .unwrap() change above — affects
        // UploadImage flow only. uploadHeadImage's rejection is already
        // surfaced via the global Axios interceptor (app/updateError); this
        // catch only prevents an unhandled promise rejection at call sites.
      }
    }
  }

  const form = useForm<FormValues>({
    shouldFocusError: true,
    mode: 'all',
    resolver: yupResolver(validationSchema),
  })

  return {
    form,
    onSubmit,
  }
}
